export const EMBARCACAO_DETAIL_TITLE = "Detalhes da Embarcação";
export const EMBARCACAO_DETAIL_MENU_LABEL = "Seções do detalhamento";

/**
 * Ponto de quebra do modo mobile, o mesmo do layout autenticado e da Tela Inicial. Abaixo dele o menu lateral de seções
 * dá lugar a um seletor no topo do corpo, que ocupa a largura toda.
 */
export const EMBARCACAO_DETAIL_MOBILE_QUERY = "(max-width: 768px)";

export const EMBARCACAO_DETAIL_EXPORT_SCOPE =
  "A exportação traz o detalhamento completo da embarcação, com todas as seções.";
export const EMBARCACAO_DETAIL_EXPORT_LIST_NAME = "detalhamento da embarcação";
